import { Navigate } from 'react-router-dom';
import { hasPermission } from '@entities/access';
import { useAuth } from '@entities/auth';
import { AmlBillingPanel } from '@features/aml-billing';

export function AmlBillingPage() {
  const { user } = useAuth();
  if (!hasPermission(user, 'aml.billing.manage')) return <Navigate to="/balance" replace />;
  return <AmlBillingPanel />;
}
